import Link from 'next/link';
import { MdArrowForward } from 'react-icons/md';
import OtherPromo from 'ui/components/molecules/OtherPromo';
import pageViewPromoDetail from 'ui/lib/gtm/pageViewPromoDetail';
import { sendDataInChunks } from 'ui/lib/collectData';
import { useEffect, useRef, useState } from 'react';
import useIsNativeView from 'ui/hooks/useIsNativeView';
import { Article } from '../../../interface';
import { promoButtonClickOption } from '../../../helpers/emarsys/promo/eventClickPromo';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import useImpressionPromo from '../../../hooks/emarsys/promo/useImpressionPromo';

interface IProps {
  anotherPromo: Article[];
  enableSharing?: boolean;
  actionClick?: (buttonName) => void;
  impressionData?: {
    pageTitle: string;
    breadCrumb: IBreadcrumbs[];
    promo?: Article;
    page_category?: string;
  };
}

const DetailPromoAnotherPromoSection = ({
  anotherPromo,
  enableSharing = false,
  actionClick,
  impressionData = { pageTitle: '', breadCrumb: [], promo: {} },
}: IProps) => {
  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

  const impressionRef = useRef(null);
  const [collectDataLayer, setCollectDataLayer] = useState([]);

  const isNativeView = useIsNativeView();

  useEffect(() => {
    if (collectDataLayer?.length > 0) {
      sendDataInChunks(
        collectDataLayer,
        4,
        (chunk) => {
          pageViewPromoDetail(chunk);
        },
        setCollectDataLayer,
        ''
      );
    }
  }, [collectDataLayer]);

  const handleBackToHomePage = () => {
    if (typeof window !== 'undefined') {
      (window as any)?.androidApp?.goToPromoList();
      (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage('goToPromoList');
    }
  };

  useImpressionPromo(
    impressionRef,
    impressionData.promo,
    impressionData.breadCrumb,
    'promo lainnya',
    {
      page_category: impressionData?.page_category,
    }
  );

  return anotherPromo?.length ? (
    <section className="my-[30px] lg:my-16" data-testid="another-promo-section" ref={impressionRef}>
      <div className="flex items-center justify-between mb-4 lg:mb-6">
        <div className="max-w-[768px]:text-base font-bold uppercase text-reliableBlack lg:text-2xl">
          Promo Lainnya
        </div>

        {!enableSharing ? (
          <Link
            href={`${PUBLIC_URL}/promosi`}
            onClick={(e) => {
              if (isNativeView) {
                e.preventDefault();
              }
              if (actionClick) {
                actionClick(promoButtonClickOption.lihatSemuaPromo);
              }
              handleBackToHomePage();
            }}
            className="bg-transparent text-reliableBlack text-[12px] font-semibold uppercase lg:text-base lg:font-medium"
          >
            <span className="flex items-center gap-2 lg:gap-4">
              Lihat semua
              <MdArrowForward color="#CE181E" size={18} />
            </span>
          </Link>
        ) : (
          <span className="text-reliableBlack text-xs font-semibold uppercase lg:text-base lg:font-medium cursor-not-allowed">
            <span className="flex items-center gap-2 lg:gap-4">
              Lihat semua
              <MdArrowForward color="#CE181E" size={18} />
            </span>
          </span>
        )}
      </div>

      {/* Another promo card */}
      <OtherPromo
        categoryGTM={'promo lainnya'}
        handleCollectDataLayer={async (data) => setCollectDataLayer((prev) => [...prev, data])}
        items={anotherPromo}
        enableSharing={enableSharing}
      />
    </section>
  ) : null;
};

export default DetailPromoAnotherPromoSection;
